import { useEffect, useRef } from 'react';
import { useIntercom } from 'react-use-intercom';
import { User } from 'v2/core/entities/user';
import useOnClickOutside from 'v2/core/hooks/useOnClickOutside';

interface UseIntercomIntegrationProps {
  baseUser: User | null;
}

export const useIntercomMessenger = ({
  baseUser,
}: UseIntercomIntegrationProps) => {
  const intercom = useIntercom();
  const intercomRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!baseUser?.intercomUserHash) {
      return;
    }
    intercom.boot({
      name: baseUser.firstName,
      email: baseUser.email,
      userHash: baseUser.intercomUserHash,
    });
    intercom.update({ hideDefaultLauncher: true });
  }, [
    baseUser?.firstName,
    baseUser?.email,
    baseUser?.intercomUserHash,
    intercom,
  ]);

  useEffect(() => {
    if (intercom?.isOpen) {
      const intercomFrame = document.getElementById('intercom-frame');

      if (intercomFrame) {
        intercomRef.current = intercomFrame as HTMLDivElement;
      }
    }
  }, [intercom?.isOpen, intercomRef]);

  useOnClickOutside(intercomRef, () => {
    intercom?.isOpen && intercom.hide();
  });
};
